import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogTitle, MatDialogClose } from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { TranslatePipe } from '@ngx-translate/core'
import { TemplateWithClient } from '../../templates.service'

export type TemplateImportDialogInputData = {
  templates: TemplateWithClient[]
}

export type TemplateImportDialogOutputData = {
  templateId: number
}

@Component({
  selector: 'app-template-import-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    MatDialogClose,
    MatButton,
    MatFormFieldModule,
    MatSelectModule,
    TranslatePipe,
  ],
  templateUrl: './template-import-dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './template-import-dialog.scss',
})
export class TemplateImportDialog {
  selectedTemplateId: number | null = null

  constructor(@Inject(MAT_DIALOG_DATA) public data: TemplateImportDialogInputData) {}

  get isImportDisabled(): boolean {
    return this.selectedTemplateId === null
  }

  get templateList(): TemplateWithClient[] {
    return this.data.templates
  }
}
